export default __webpack_public_path__ + "static/media/pictogramBeaconDownload64.5a28caf4.svg";